// extracted by mini-css-extract-plugin
export default {"header":"TipHeader_header__QE9o1"};